<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1RGsx5/media/FC-9781685621377.jpg?1695340671639" alt="This image is the cover for the book Broken Tusk"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Broken Tusk
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><em><span style='font-size:16px;font-family:"Arial Nova",sans-serif;'>Broken Tusk</span></em><span style='font-size:16px;font-family:"Arial Nova",sans-serif;'> is a heart-wrenching tale that follows the trials and tribulations of a family of African elephants, narrated by the hero, a young male named Broken Tusk. From daily encounters with natural disasters to the cruel and devastating effects of human actions, Broken Tusk guides readers through the soulful journey of his family’s incalculable suffering. Alongside the hardships, readers also witness moments of joy, including playful games, mud baths, and even a bit of romance for Broken Tusk. With simple writing and short sentences, this absorbing story serves as an eye-opener for readers of all ages and provides an educational insight into the lives of African elephants.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Puthalath Raghuprasad
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0cm;font-size:16px;font-family:"Times New Roman",serif;text-align:justify;'><span style="font-size:14px;">Puthalath Raghuprasad has many talents. His first talent is painting. His favorite medium is oil, and he creates realistic pictures on canvas, including portraits, scenery/landscapes, birds, animals, and flowers. His second talent is writing in prose, but lately, he has also written several poems. He is also proficient in inventing; he holds 21 US patents, and two of them are at different stages of manufacturing. Finally, he has formulated his own theory about the universe in which gravity and the ever-present axial rotation cooperate to give rise to the motions of all celestial bodies.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4e1e3cd1